import monarchConfig from "./monarchConfig";
import logger from "@/lib/logger";
import newrelic from "@/lib/monitoring/newrelic";
import { MonarchPayload, MonarchHeaders } from "./types";

/**
 * Makes a request to the Monarch API to evaluate a rule
 */
export async function callMonarchApi(
  ruleId: string,
  payload: MonarchPayload,
  headers: Partial<MonarchHeaders> = {},
): Promise<any> {
  try {
    const response = await fetch(
      `${monarchConfig.endpoint}/api/v1/evaluate/rule/${monarchConfig.sourceId}/${ruleId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Token: monarchConfig.token,
          Consent: "true",
          ...headers,
        },
        body: JSON.stringify(payload),
      },
    );

    return await response.json();
  } catch (error) {
    logger.error(`Error calling Monarch API:`, error);
    newrelic.noticeError(error as Error, {
      message: "Error calling Monarch API",
    });
    return null;
  }
}
